<template>
    <div>
        <avue-crud :data="data" :option="option" :search.sync="search" @selection-change="selectionChange"
                   @size-change="sizeChange"
                   :page.sync="page" @current-change="currentChange" @search-change="searchChange"
                   @search-reset="resetChange">
            <template slot-scope="scope" slot="menuLeft">
                <el-button class="custom" @click="applicantBtn" v-if="user_type.user_type!==1">上传申请人身份证明</el-button>
                <!--                <el-button class="custom" @click="registerBtn">发起立案</el-button>-->
                <!--                <el-button class="custom" @click="batchBtn">批量导入</el-button>-->
                <el-button class="custom" @click="importCaseBtn">批量导入商事调解案件</el-button>
                <el-button class="custom" @click="bindEvidenceBtn">绑定证据清单</el-button>
                <el-button class="custom" @click="bindSupplementBtn">绑定补充证据清单</el-button>
                <el-button class="custom" @click="batchSubmit">根据案件批号提交至商事调解中心</el-button>
                <!--                <el-button class="custom" @click="batchSubmitBtn">批量提交至商事调解中心</el-button>-->
            </template>
            <template slot="menuBtn" slot-scope="scope">
                <el-dropdown-item class="pull-down" @click.native="mediateListBtn(scope.row)">证据材料</el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="supplementBtn(scope.row)">补充证据</el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="detailsBtn(scope.row)">案件详情</el-dropdown-item>
                <!--                案件为待提交状态显示删除案件-->
                <el-dropdown-item class="pull-down" @click.native="deleteBtn(scope.row)" v-if="scope.row.status==0">
                    删除案件
                </el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="modifyBtn(scope.row)">修改立案信息</el-dropdown-item>
            </template>
            <template slot="case_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.case_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.case_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="zhcai_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.zhcai_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.zhcai_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="user_name" slot-scope="scope" >
                <el-tooltip :content="scope.row.user_name" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.user_name }}</p>
                </el-tooltip>
            </template>
            <template slot="doc_title" slot-scope="scope" >
                <el-tooltip :content="scope.row.doc_title" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.doc_title }}</p>
                </el-tooltip>
            </template>
            <template slot="contract_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.contract_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.contract_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="signers_txt" slot-scope="scope" >
                <el-tooltip :content="scope.row.signers_txt" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.signers_txt }}</p>
                </el-tooltip>
            </template>
            <template slot="tijiao_time" slot-scope="scope" >
                <el-tooltip :content="scope.row.tijiao_time" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.tijiao_time }}</p>
                </el-tooltip>
            </template>
            <template slot="lian_time" slot-scope="scope" >
                <el-tooltip :content="scope.row.lian_time" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.lian_time }}</p>
                </el-tooltip>
            </template>
            <template slot="jie_an_time" slot-scope="scope" >
                <el-tooltip :content="scope.row.jie_an_time" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.jie_an_time }}</p>
                </el-tooltip>
            </template>
        </avue-crud>
        <!--        获取商事调解中心列表-->
        <el-dialog
                title="提交商事调解中心"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                width="30%">
            <el-form ref="form" :model="form" label-width="110px" :rules="rules">
                <el-form-item label="商事调解中心" prop="center_id">
                    <el-select v-model="form.center_id" placeholder="请选择活动区域">
                        <el-option v-for="(item,index) in dataList " :label="item.name" :value="item.id"
                                   :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="案件批号" prop="pi_sn">
                    <el-input v-model="form.pi_sn"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="confirmSubmitBtn">确 定</el-button>
            </span>
        </el-dialog>
        <!--        绑定证据清单-->
        <el-dialog
                title="关联证据清单"
                :visible.sync="evidence"
                :close-on-click-modal="false"
                width="70%">
            <avue-crud :data="evidenceData" :option="option2">
                <template slot-scope="scope" slot="menu">
                    <el-button type="primary" plain @click="bindListBtn(scope.row)">绑定</el-button>
                </template>
            </avue-crud>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="evidence = false">关 闭</el-button>
            </span>
        </el-dialog>
        <!--        绑定补充证据清单-->
        <el-dialog
                title="关联补充证据清单"
                :visible.sync="supplement"
                :close-on-click-modal="false"
                width="70%">
            <avue-crud :data="supplementData" :option="option3">
                <template slot-scope="scope" slot="menu">
                    <el-button type="primary" plain @click="supplementListBtn(scope.row)">绑定</el-button>
                </template>
            </avue-crud>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="supplement = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        bulkSubmissionCase, byLotNumber, deleteCase_center,
        evidenceList_center,
        mediateList_center,
        mediationCenterList, supplementary_center
    } from '../../../api/mediationCenter';
    import { associatedList, associationList } from '../../../api/contract';

    export default {
        name: 'myMediation',
        data() {
            return {
                form: {
                    center_id: '',
                    pi_sn: ''
                },
                rules: {
                    center_id: [
                        { required: true, message: '请选择商事调解中心', trigger: 'change' }
                    ],
                    pi_sn: [
                        { required: true, message: '请输入案件批号', trigger: 'blur' }
                    ]
                },
                dialogVisible: false, //获取商事调解中心列表 对话框
                evidence: false, //关联证据清单 对话框
                supplement: false, //关联补充证据清单 对话框
                user_type: '',
                dataList: [], //商事调解中心列表
                evidenceData: [], //证据清单列表
                supplementData: [], //补充证据清单列表
                option1: {
                    stripe: true,
                    addBtn: false,  //新增按钮
                    align: 'center',  //文本居中
                    menuAlign: 'center', //操作栏居中
                    columnBtn: false,  //列动态显隐按钮
                    refreshBtn: false,  //刷新按钮
                    editBtn: false,  //编辑按钮
                    delBtn: false,  //删除按钮
                    column: [
                        {
                            label: '调解中心id',
                            prop: 'id'
                        }, {
                            label: '调解中心名称',
                            prop: 'name'
                        }
                    ]
                },
                option2: {
                    stripe: true,
                    addBtn: false,  //新增按钮
                    align: 'center',  //文本居中
                    menuAlign: 'center', //操作栏居中
                    columnBtn: false,  //列动态显隐按钮
                    refreshBtn: false,  //刷新按钮
                    editBtn: false,  //编辑按钮
                    delBtn: false,  //删除按钮
                    column: [
                        {
                            label: '证据清单id',
                            prop: 'id'
                        },
                        {
                            label: '证据清单名称',
                            prop: 'name'
                        }
                    ]
                },
                option3: {
                    stripe: true,
                    addBtn: false,  //新增按钮
                    align: 'center',  //文本居中
                    menuAlign: 'center', //操作栏居中
                    columnBtn: false,  //列动态显隐按钮
                    refreshBtn: false,  //刷新按钮
                    editBtn: false,  //编辑按钮
                    delBtn: false,  //删除按钮
                    menuWidth: 300,  //操作栏宽度设置
                    column: [
                        {
                            label: '补充证据清单id',
                            prop: 'id'
                        },
                        {
                            label: '补充证据清单名称',
                            prop: 'name'
                        }
                    ]
                },
                page: {
                    currentPage: 1,
                    total: 20,  //总数
                    pageSize: 10
                },
                search: {
                    doc_title: '', //合同名称
                    signers_txt: '', //被申请人
                    status: '' //案件状态
                },
                argument: {
                    req_type: 0,
                    limit: '',
                    page: 1,
                    doc_title: '',
                    status: '',
                    signers_txt: ''
                },
                data: [],
                option: {
                    menuType: 'menu',
                    menuBtnTitle: '操作',
                    stripe: true,
                    selection: true, //批量选择
                    addBtn: false,  //新增按钮
                    align: 'center',  //文本居中
                    menuAlign: 'center', //操作栏居中
                    columnBtn: false,  //列动态显隐按钮
                    refreshBtn: false,  //刷新按钮
                    editBtn: false,  //编辑按钮
                    delBtn: false,  //删除按钮
                    menuWidth: 150,  //操作栏宽度设置
                    column: [
                        {
                            label: '调解案件ID',
                            prop: 'id'
                        }, {
                            label: '案件编号',
                            prop: 'case_sn'
                        }, {
                            label: '仲裁案号',
                            prop: 'zhcai_sn'
                        }, {
                            label: '案件批号',
                            prop: 'pi_sn'
                        }, {
                            label: '申请人',
                            prop: 'user_name'
                        }, {
                            label: '合同名称',
                            prop: 'doc_title',
                            search: true
                        }, {
                            label: '合同编号',
                            prop: 'contract_sn'
                        }, {
                            label: '合同类型',
                            prop: 'product_name'
                        }, {
                            label: '被申请人',
                            prop: 'signers_txt',
                            search: true
                        }, {
                            label: '调解员',
                            prop: 'lawyer_name'
                        }, {
                            label: '案件状态',
                            prop: 'status',
                            search: true,
                            type: 'select',
                            width:120,
                            dicData: [
                                {
                                    label: '待提交',
                                    value: 0
                                },
                                {
                                    label: '调解助理沟通中',
                                    value: 1
                                },
                                {
                                    label: '调解员调解中',
                                    value: 2
                                },
                                {
                                    label: '法务助理处理中',
                                    value: 3
                                },
                                {
                                    label: '仲裁委审核中',
                                    value: 4
                                },
                                {
                                    label: '仲裁委审核驳回',
                                    value: 5
                                },
                                {
                                    label: '待缴费',
                                    value: 6
                                },
                                {
                                    label: '仲裁委调解中',
                                    value: 7
                                },
                                {
                                    label: '已结案',
                                    value: 8
                                },
                                {
                                    label: '已撤案',
                                    value: 9
                                },
                                {
                                    label: '调解失败',
                                    value: 10
                                }
                            ]
                        }, {
                            label: '提交案件时间',
                            prop: 'tijiao_time'
                        }, {
                            label: '立案时间',
                            prop: 'lian_time'
                        }, {
                            label: '结案时间',
                            prop: 'jie_an_time'
                        }
                    ]
                }
            };
        },
        methods: {
            //上传申请人身份证明
            applicantBtn() {
                this.$router.push({ path: '/applicantPage' });
            },
            //批量操作
            selectionChange(list) {
                this.ids = [];
                list.forEach(res => {
                    this.ids.push(res.id);
                });
            },
            //切换每一页数据
            sizeChange(val) {
                this.page.pageSize = val;
                this.argument.limit = val;
                this.getList();
            },
            //分页
            currentChange(num) {
                this.argument.page = num;
                if (this.argument.doc_title == '' && this.argument.signers_txt == '' && this.argument.status == '') {
                    this.getList();
                    sessionStorage.setItem('center', num);
                } else {
                    this.getList();
                    sessionStorage.setItem('centerSearch', num);
                }
            },
            //搜索
            searchChange(params, done) {
                this.argument.doc_title = params.doc_title;
                this.argument.signers_txt = params.signers_txt;
                this.argument.status = params.status;
                this.getList();
                sessionStorage.setItem('centerSearch', 1);
                sessionStorage.setItem('centerParams', JSON.stringify(params));
                done();
            },
            //重置搜索
            resetChange() {
                this.argument.doc_title = '';
                this.argument.signers_txt = '';
                this.argument.status = '';
                this.argument.limit = 10;
                this.argument.page = 1;
                sessionStorage.removeItem('center');
                sessionStorage.removeItem('centerSearch');
                sessionStorage.removeItem('centerParams');
                this.getList();
            },
            //发起立案
            registerBtn() {
                this.$router.push({ path: 'mediationFiling_center' });
            },
            getList() {
                //获取列表数据
                mediateList_center(this.argument).then(res => {
                    if (res.code == 200) {
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                        this.page.currentPage = this.argument.page;
                    }
                });
            },
            //批量导入
            batchBtn() {
                this.$router.push({ path: 'batch_center' });
            },
            //获取商事调解中心列表
            batchSubmitBtn() {
                if (this.ids == undefined || this.ids == '') {
                    this.$message.error('请选择要提交的案件');
                } else {
                    this.dialogVisible = true;
                    mediationCenterList().then(res => {
                        if (res.code == 200) {
                            this.dataList = res.data.list;
                        } else {
                            this.$message.error(res.msg);
                        }
                    });
                }

            },
            //批量提交至商事调解中心
            submitBtn(row) {
                let data = {
                    center_id: row.id,
                    case_ids: this.ids
                };
                this.$confirm('请确认是否批量提交案件至该商事调解中心 ', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    bulkSubmissionCase(data).then(res => {
                        if (res.code == 200) {
                            this.dialogVisible = false;
                            this.$message.success(res.msg);
                            this.$nextTick(() => {
                                this.getList();
                            });
                        } else {
                            this.$message.error(res.msg);
                        }
                    });
                }).catch(() => {

                });
            },
            //批量绑定证据清单
            bindEvidenceBtn() {
                if (this.ids == undefined || this.ids == '') {
                    this.$message.error('请选择要绑定的案件');
                } else {
                    //获取用户关联的证件清单
                    associatedList().then(res => {
                        if (res.code == 200) {
                            this.evidence = true;
                            this.evidenceData = res.data.list;
                        } else {
                            this.$message.error(res.msg);
                        }
                    });
                }
            },
            //绑定证据清单
            bindListBtn(row) {
                let data = {
                    case_ids: this.ids,
                    product_id: row.id
                };
                this.$confirm('请确认是否将案件绑定为该证据清单 ', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    evidenceList_center(data).then(res => {
                        if (res.code == 200) {
                            this.$message.success(res.msg);
                            this.evidence = false;
                            this.$nextTick(() => {
                                this.getList();
                            });
                        } else {
                            this.$message.error(res.msg);
                        }
                    });
                }).catch(() => {

                });
            },
            //绑定补充证据清单
            bindSupplementBtn() {
                if (this.ids == undefined || this.ids == '') {
                    this.$message.error('请选择要绑定的案件');
                } else {
                    associationList().then(res => {
                        this.supplement = true;
                        this.supplementData = res.data.list;
                    });
                }
            },
            //绑定补充证据清单
            supplementListBtn(row) {
                let data = {
                    case_ids: this.ids,
                    extra_id: row.id
                };
                this.$confirm('请确认是否将案件绑定为该证据清单 ', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    supplementary_center(data).then(res => {
                        if (res.code == 200) {
                            this.$message.success(res.msg);
                            this.supplement = false;
                            this.$nextTick(() => {
                                this.getList();
                            });
                        } else {
                            this.$message.error(res.msg);
                        }
                    });
                }).catch(() => {

                });
            },
            //证据清单
            mediateListBtn(row) {
                this.$router.push({ path: '/mediateList_center', query: { id: row.id } });
            },
            //上传补充证据
            supplementBtn(row) {
                this.$router.push({ path: '/mediateSupplement_center', query: { id: row.id } });
            },
            //案件详情
            detailsBtn(row) {
                this.$router.push({ path: '/details_center', query: { id: row.id } });
            },
            //删除案件
            deleteBtn(row) {
                this.$confirm('请确认是否将该案件删除 ', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteCase_center({ case_id: row.id }).then(res => {
                        if (res.code == 200) {
                            this.$message.success(res.msg);
                            this.$nextTick(() => {
                                this.getList();
                            });
                        } else {
                            this.$message.error(res.msg);
                        }
                    });
                }).catch(() => {

                });
            },
            //修改立案信息
            modifyBtn(row) {
                this.$router.push({ path: '/editInformation_center', query: { id: row.id } });
            },
            //批量导入商事调解中心
            importCaseBtn() {
                this.$router.push({ path: '/importMediationCase' });
            },
            //根据案件批号上传至商事调解中心
            batchSubmit() {
                mediationCenterList().then(res => {
                    if (res.code == 200) {
                        this.dialogVisible = true;
                        this.dataList = res.data.list;
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },
            //确定提交至商事调解中心
            confirmSubmitBtn() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        let data = {
                            center_id: this.form.center_id,
                            pi_sn: this.form.pi_sn
                        };
                        byLotNumber(data).then(res => {
                            if (res.code == 200) {
                                this.dialogVisible = false;
                                this.$message.success(res.msg);
                                this.$refs.form.resetFields();
                                this.$nextTick(() => {
                                    this.getList();
                                });
                            } else {
                                this.$message.error(res.msg);
                                this.dialogVisible = false;
                                this.$refs.form.resetFields();
                            }
                        });
                    } else {
                        return false;
                    }
                });
            }
        },
        created() {
            this.argument.limit = this.page.pageSize;

            let centerSearch = Number(sessionStorage.getItem('centerSearch'));
            if (centerSearch) {
                let centerParams = JSON.parse(sessionStorage.getItem('centerParams'));
                //回显的数据
                this.search = centerParams;

                let objParams = {
                    req_type: 0,
                    limit: this.page.pageSize,
                    page: centerSearch,
                    doc_title: centerParams.doc_title,
                    status: centerParams.status,
                    signers_txt: centerParams.signers_txt
                };
                this.argument = objParams;

                mediateList_center(objParams).then(res => {
                    if (res.code == 200) {
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                        this.page.currentPage = centerSearch;
                    }
                });
            } else {
                let centerNum = Number(sessionStorage.getItem('center'));
                if (centerNum === 0) {
                    this.getList();
                } else {
                    this.argument.page = centerNum;
                    mediateList_center(this.argument).then(res => {
                        if (res.code == 200) {
                            this.data = res.data.list;
                            this.page.total = res.data.count;
                            this.page.currentPage = centerNum;
                        }
                    });
                }
            }
            //获取身份信息
            this.user_type = JSON.parse(sessionStorage.getItem('shenfen'));
        }
    };
</script>

<style scoped>
    .custom {
        background-color: #3e62f6;
        color: #fff;
    }

    .schedule {
        height: 400px;
        overflow: auto;
    }

    /deep/ .el-timeline {
        width: 50%;
        margin: auto;
    }

    /deep/ .el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
    }

    /deep/ .el-icon-arrow-down {
        font-size: 15px;
    }

    .pull-down {
        padding: 5px 30px !important;
    }

    /deep/ .avue-form__group--flex {
        align-items: flex-end;
    }

    /deep/ .avue-form__menu {
        width: 200px;
    }

    /deep/ .el-dialog__body {
        max-height: 400px;
        overflow-y: scroll;
    }

    .el-select {
        width: 100%;
    }
    .textStyle{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: default;
        margin:0;
    }
</style>
